module.exports = __webpack_public_path__ + "static/img/main6.cc0a204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/programme/main6.png
// module id = pxkL
// module chunks = 1